import Vue from 'vue'

Vue.mixin({
  methods: {
    pls_format_phoneNumber(phone_number) {
      if (phone_number == null){
        return '';
      }
      phone_number = phone_number.replace(/\D/g,'');
      if (phone_number.substring(0,1) == "1"){
        phone_number = phone_number.substring(1);
        var formatted_phone_number_string = "(" + phone_number.substring(0,3) + ") " + phone_number.substring(3,6) + "-" + phone_number.substring(6,10);
        return formatted_phone_number_string;
      }else if (phone_number.substring(0,2) == "44"){
        phone_number = phone_number.substring(2);
        if (phone_number.substring(0,3) == "808"){
          var formatted_phone_number_string = "0" + phone_number.substring(0,3) + " " + phone_number.substring(3,6) + " " + phone_number.substring(6,10);
        }else{
          var formatted_phone_number_string = "0" + phone_number.substring(0,4) + " " + phone_number.substring(4,10);
        }
        return formatted_phone_number_string;
      }
    },
    pls_format_seconds(seconds){
      if (typeof seconds === 'undefined' || !seconds){
        return ''
      }
      var sec_num = parseInt(seconds, 10); // don't forget the second param
      var hours   = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      var seconds = sec_num - (hours * 3600) - (minutes * 60);

      if (hours   < 10) {hours   = "0"+hours;}
      if (minutes < 10) {minutes = "0"+minutes;}
      if (seconds < 10) {seconds = "0"+seconds;}

      if (hours == "00"){
        return minutes+':'+seconds;
      }else{
        return hours+':'+minutes+':'+seconds;
      }
    },
    pls_format_date(date){
      if (typeof date === 'undefined'){
        return '';
      }
      var dateSplit = date.split("-");
      var year = parseInt(dateSplit[0]);
      var month = parseInt(dateSplit[1]);
      var day = parseInt(dateSplit[2]);
      year = year - 2000;
      if (this.$auth?.user?.phone_system?.phone_number?.substring(0,2) == "44"){
        var dateString = day + "/" + month + "/" + year;
      }else{
        var dateString = month + "/" + day + "/" + year;
      }
      return dateString;
    },
    pls_format_time(time){
      if (typeof time === 'undefined'){
        return '';
      }
      var timeSplit = time.split(".");
      var timeString = timeSplit[0];

      // AM/PM from 24 hour time
      var timeSplit = timeString.split(":")
      var hour = parseInt(timeSplit[0]);
      // Standard 12-hour clock. The old logic used `if (hour > 12)`, which
      // left noon (12) tagged "AM" and rendered midnight (0) as "0:xx AM"
      // instead of "12:xx AM".
      var amPmString = (hour >= 12) ? "PM" : "AM";
      hour = hour % 12;
      if (hour === 0){ hour = 12; }

      // Put it all back together
      timeString = hour + ":" + timeSplit[1] + " " + amPmString;

      return timeString;
    },
    pls_format_date_time(dateTime){
      if (typeof dateTime === 'undefined'){
        return '';
      }
      var dateTimeSplit = dateTime.split("T");
      var date = this.pls_format_date(dateTimeSplit[0]);
      var time = this.pls_format_time(dateTimeSplit[1]);
      var dateTimeString = date + " " + time;
      return dateTimeString;
    },
    pls_formate_date_nth(d){
      if (d > 3 && d < 21) return 'th';
      switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
      }
    },
    pls_format_date_v2(date,with_timezone=true,long_form=false){
      // console.log('pls_format_date', date, with_timezone, long_form);
      if (typeof date === 'undefined'){
        return '';
      }
      var dateProp = new Date(date);
      if (long_form){
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const weekdayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var year = dateProp.getFullYear();
        var month = monthNames[dateProp.getMonth()];
        var day = weekdayNames[dateProp.getDay()];
        var dateString = day + ", " + month + " " + dateProp.getDate() + this.pls_formate_date_nth(dateProp.getDate()) + ", " + year;
      }else{
        // getFullYear(), not the deprecated getYear() which returns
        // year-1900 (e.g. 126 for 2026).
        var year = dateProp.getFullYear();
        var month = dateProp.getMonth() + 1;
        var day = dateProp.getDate();
        if (this.$auth?.user?.phone_system?.phone_number?.substring(0,2) == "44"){
          var dateString = day + "/" + month + "/" + year;
        }else{
          var dateString = month + "/" + day + "/" + year;
        }
      }
      return dateString;
    },
    pls_format_time_v2(time, with_timezone=true){
      // console.log('pls_format_time', time, with_timezone);
      if (typeof time === 'undefined'){
        return '';
      }
      var timeProp = new Date(time);
      // AM/PM from 24 hour time
      var hour = timeProp.getHours();
      // Zero-pad minutes (getMinutes() returns 5, not "05") and normalize
      // the hour so midnight (0) shows "12:xx AM" and noon (12) "12:xx PM".
      var minutes = timeProp.getMinutes().toString().padStart(2, '0');
      var amPmString = (hour >= 12) ? "PM" : "AM";
      hour = hour % 12;
      if (hour === 0){ hour = 12; }
      // Put it all back together
      var timeString = hour + ":" + minutes + " " + amPmString;
      return timeString;
    },
    pls_format_date_time_v2(dateTime,with_timezone=true,long_form=false){
      // console.log('pls_format_date_time', dateTime, with_timezone, long_form);
      if (typeof dateTime === 'undefined'){
        return '';
      }
      var dateProp = new Date(dateTime);
      var date = this.pls_format_date_v2(dateProp, with_timezone, long_form);
      var time = this.pls_format_time_v2(dateProp, with_timezone);
      if (long_form){
        var dateTimeString = date + " at " + time;
      }else{
        var dateTimeString = date + " " + time;
      }
      return dateTimeString;
    },
    pls_format_snakecase_to_title(str){
      return str.split('_').map(function (item) {
        return item.charAt(0).toUpperCase() + item.substring(1);
      }).join(' ');
    },
    pls_format_number(x){
      if (typeof x === 'undefined'){
        return '';
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    pls_date_time_to_epoch(date_time){
      var someDate = new Date(date_time);
      return parseInt(someDate.getTime() / 1000);
    },
    pls_get_ordinal_num(n) {
      return n + (n > 0 ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10] : '');
    },
  }
})
